import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { lazy } from "react";

// Lazily loaded — the personal skills manager isn't needed on the default
// /chat landing, so it ships as its own chunk.
const SkillsPage = lazy(() =>
  import("../components/SkillsPage").then((m) => ({ default: m.SkillsPage })),
);

/** Skills route — the user's personal skills manager. */
export function createSkillsRoutes<TParent extends AnyRoute>(parent: TParent) {
  const list = createRoute({
    getParentRoute: () => parent,
    path: "/skills",
    component: SkillsPage,
  });
  return [list];
}
